import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from 'reactstrap';

const CommonAccordion = ({ heading, children, defaultValue = null }) => {
  const [open, setOpen] = useState(defaultValue);
  const toggleAccordion = (id) => {
    if (open === id) {
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <Accordion open={open} toggle={toggleAccordion}>
      <AccordionItem className="border-0 rounded-0">
        <AccordionHeader targetId="1">{heading}</AccordionHeader>
        <AccordionBody
          style={{ border: '1px solid #EBEBEB' }}
          s
          accordionId="1"
        >
          {children}
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
};

export default CommonAccordion;
